import React from 'react'
import { useIntl } from 'react-intl'
import Skeleton from 'react-loading-skeleton'

const FundingDropdownSkeleton = () => {

    const { formatMessage } = useIntl()

    return (
        <div className='my-4'>
            <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button captable-accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <h4 className='text-success m-0'>{formatMessage({ id: 'Series A' })}</h4>
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <table className="table">
                                {/* <thead>
                                    <tr>
                                        <th className='font-size-16 fw-bold' scope="col">
                                            <Skeleton
                                                width={`100%`}
                                                height={40}
                                                baseColor="var(--kt-skeleton-bg-color)"
                                                highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                            />
                                        </th>
                                        <th className='font-size-16 fw-bold' scope="col">
                                            <Skeleton
                                                width={`100%`}
                                                height={40}
                                                baseColor="var(--kt-skeleton-bg-color)"
                                                highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                            />
                                        </th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    <>
                                        <tr>
                                            <td className='text-muted'>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                            <td>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-primary'>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                            <td>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-success'>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                            <td>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-warning'>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                            <td>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-warning'>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                            <td>
                                                <Skeleton
                                                    width={`100%`}
                                                    height={20}
                                                    baseColor="var(--kt-skeleton-bg-color)"
                                                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                                                />
                                            </td>
                                        </tr>
                                    </>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FundingDropdownSkeleton
